


























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ReservationTableMobileTile from "./ReservationTableMobileTile.vue";
import { DateTime } from "luxon";
import VReservation from "@/shared/models/vReservation";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import RequireRole from "@/components/misc/RequireRole.vue";
import {
  cleanUpPhoneNumber,
  cleanUpLeadingZeroes,
  appendPrefixIfMissing,
} from "@/shared/commonFunctions";
import { AccomodationUnitStatusEnum } from "@/shared/models/enums.type";
import { formatLocaleDate } from "@/shared/dateFormatUtils";

@Component({
  components: {
    ReservationTableMobileTile,
    RequireRole,
  },
})
export default class ReservationsTableMobileTile extends Vue {
  @Prop() unit?: any;
  @Prop() occupancy?: boolean;
  @Prop() fpNum?: number;

  @Getter("language/language") language?: string;
  @Getter("auth/claims") claims?: JwtClaims;

  get allowedToModifyReservations() {
    return policyChecker("MODIFY_RESERVATIONS")(this.claims);
  }

  get isAllowedToSeePrices() {
    return (
      policyChecker("MODIFIED_PRICES")(this.claims) ||
      policyChecker("ACTUAL_PRICES")(this.claims)
    );
  }

  get isAllowedToSeeOwnerPrices() {
    return policyChecker("INPUT_PRICES")(this.claims);
  }

  get isAllowedToModifyDistributionChannel() {
    return policyChecker("MODIFY_DISTRIBUTION_CHANNEL")(this.claims);
  }

  get isAllowedToSeeTelephoneNumber() {
    return policyChecker("READ_CUSTOMER_TELEPHONE_NUMBER")(this.claims);
  }

  get reservationDateUI() {
    const arrivalDate = DateTime.fromISO(this.unit.arrivalDate);
    const departureDate = DateTime.fromISO(this.unit.departureDate);

    if (!this.occupancy && this.unit.arrivalDate !== undefined) {
      return (
        formatLocaleDate(arrivalDate, this.language) +
        " - " +
        formatLocaleDate(departureDate, this.language)
      );
    } else {
      return this.$d(new Date(this.unit.date));
    }
  }

  get reservationCancellationDate() {
    if (this.unit.cancelationDate !== undefined) {
      const cancellationDate = DateTime.fromISO(this.unit.cancelationDate)
      return ' (' + formatLocaleDate(cancellationDate, this.language) + ')'
    } 
    return ''
  }

  get cancellationWithinFreePeriod() {
    return '<v-icon medium>fa fa-exclamation</v-icon>'
  }

  get currencyCodeUI() {
    return this.unit.currencyCode ?? "EUR";
  }

  get translatedStatus() {
    switch (this.unit.statusName) {
      case "No show":
        return this.$t("t.ReservationStatus.NoShow");
      case "Checked-in":
        return this.$t("t.ReservationStatus.CheckedIn");
      case "Checked-out":
        return this.$t("t.ReservationStatus.CheckedOut");
    }

    return this.$t("t.ReservationStatus." + this.unit.statusName);
  }

  get expirationDate() {
    if (this.unit.optionExpirationDate && this.unit.statusId === 1) {
      return " - " + this.$d(new Date(this.unit.optionExpirationDate));
    }
    return "";
  }

  get otaInfo() {
    if (this.unit.otachannelName) {
      return (
        this.unit.otachannelName +
        (this.unit.otareservationId
          ? " (ID " + this.unit.otareservationId + ")"
          : "")
      );
    }
    return "";
  }

  get numberOfPeople() {
    if (this.unit.numberOfAdults || this.unit.numberOfChildren) {
      return (
        " (" +
        this.unit.numberOfAdults +
        " + " +
        this.unit.numberOfChildren +
        ")"
      );
    }
    return "";
  }

  get guestName() {
    return (
      this.unit.firstGuestName ??
      this.unit.guestPlaceholder ??
      this.unit.reservationHolderName
    );
  }

  get telephoneNumber() {
    if (this.unit.firstGuestName && this.unit.firstGuestTelephoneNumber) {
      return this.unit.firstGuestTelephoneNumber;
    } else if (
      !this.unit.guestPlaceholder &&
      this.unit.reservationHolderName &&
      this.unit.reservationHolderTelephoneNumber
    ) {
      return this.unit.reservationHolderTelephoneNumber;
    }

    return undefined;
  }

  get whatsAppHref() {
    return this.telephoneNumber
      ? "https://wa.me/" +
          cleanUpLeadingZeroes(cleanUpPhoneNumber(this.telephoneNumber))
      : "";
  }

  get phoneHref() {
    let phoneNumber = this.telephoneNumber
      ? cleanUpPhoneNumber(this.telephoneNumber)
      : "";

    phoneNumber = appendPrefixIfMissing(phoneNumber);

    return "tel:" + phoneNumber;
  }

  get smsHref() {
    let phoneNumber = this.telephoneNumber
      ? "sms:" + cleanUpPhoneNumber(this.telephoneNumber)
      : "";

    phoneNumber = appendPrefixIfMissing(phoneNumber);

    return "sms:" + phoneNumber;
  }

  openItemDetails(item: VReservation) {
    if (!this.allowedToModifyReservations) {
      return;
    }

    this.$emit("open-modal", {
      resId: item.reservationId,
      scrollId: item.reservationAccUnitTypeId,
    });
  }

  get showStatusIcon() {
    if (
      this.unit.accomodationUnitStatus &&
      policyChecker("UNIT_STATUS")(this.claims)
    ) {
      return (
        this.unit.accomodationUnitStatus != AccomodationUnitStatusEnum.Clean
      );
    }
    return false;
  }

  getStatusColor() {
    switch (this.unit?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.NeedsRepair:
        return ["red-text"];
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.RepairInProgress:
        return ["red-text"];
      default:
        return [""];
    }
  }

  getStatusIcon() {
    switch (this.unit?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.NeedsRepair:
        return "fa-tools";
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.RepairInProgress:
        return "fa-tools";
      default:
        return "";
    }
  }

  getHourAndMinute(time: string) {
    if (!time) return "";

    const parts = time.split(":");
    return `${parts[0]}:${parts[1]}`;
  }
}
